import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import { ReactComponent as Exclamation } from 'assets/icons/exclamation-circle-solid.svg';

const WarningPanel = ({
  testId,
  actionText,
  text,
  text2,
  onClick,
  className,
}) => {
  return (
    <div
      data-testid={testId}
      className={`${className} text-javelin-gray-dark card p-7 lg:px-12 lg:h-40 flex flex-col lg:flex-row items-center justify-between rounded-md`}
    >
      <div className="flex flex-col lg:flex-row text-center lg:text-left items-center justify-between lg:mr-4 mb-4 lg:mb-0">
        <Exclamation
          color="text-green-500"
          className="fill-current text-javelin-gray-dark text-opacity-80 bg-white w-11 h-10 flex-shrink-0"
        />
        <div className="flex flex-col mt-5 lg:mt-0 leading-loose flex-auto lg:mx-7 box-border">
          <span className="text-sm font-semibold">{text}</span>
          {!!text2 && (
            <span className="text-sm text-gray-400 mt-2">{text2}</span>
          )}
        </div>
      </div>
      <Button
        testId="dismiss"
        className="btn-secondary h-12 text-base px-0 w-48"
        onClick={onClick}
        title={actionText}
      />
    </div>
  );
};

WarningPanel.propTypes = {
  testId: PropTypes.string,
  onClick: PropTypes.func,
  actionText: PropTypes.string,
  text: PropTypes.string,
  text2: PropTypes.string,
  className: PropTypes.string,
};
WarningPanel.defaultProps = {
  testId: 'warning-panel',
  actionText: 'Take Action',
  className: 'mb-5 lg:mb-7',
};

export default memo(WarningPanel);
